<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govbook-container">
      <div class="footer-columns">
        <nav class="footer-column" aria-labelledby="footer-heading-ceremonies">
          <h4 id="footer-heading-ceremonies">Ceremonies &amp; Formation</h4>
          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/marriage-and-cp">Marriage &amp; Civil Partnership</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/citizenship">Citizenship</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/renewal-of-vows">Renewal of Vows</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/namingceremonies">Naming</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/faq">FAQs</a>
            </li>
          </ul>
        </nav>

        <nav class="footer-column" aria-labelledby="footer-heading-about">
          <h4 id="footer-heading-about">About Us</h4>
          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/contact-us">Contact Us</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/council-ceremony-room-ceremonies">Ceremony Rooms</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/brochure">Brochure</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshire.gov.uk/council/data-protection-and-foi/information-and-data-sharing/privacy-statement">Privacy
                &amp; Data Protection</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/search">Search</a>
            </li>
            <li class="menu-item">
              <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
            </li>
          </ul>
        </nav>

        <nav class="footer-column" aria-labelledby="footer-heading-partners">
          <h4 id="footer-heading-partners">Partners</h4>
          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/approved-venue">Approved Venues</a>
            </li>
          </ul>
        </nav>

        <nav class="footer-column" aria-labelledby="footer-heading-legal">
          <h4 id="footer-heading-legal">Legal</h4>
          <ul class="menu menu--footer">
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/fees">Fees</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/ceremony-terms-and-conditions">Terms &amp;
                Conditions for Ceremonies</a>
            </li>
            <li class="menu-item">
              <a target="_blank" rel="noopener noreferrer" class="footer-links"
                href="https://www.cambridgeshireceremonies.co.uk/notice-terms-and-conditions">Terms &amp; Conditions
                for Notices</a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- Council crest sits centred beneath the link columns, as on
           cambridgeshireceremonies.co.uk -->
      <div class="footer-crest">
        <a target="_blank" rel="noopener noreferrer"
          aria-label="Cambridgeshire County Council births, deaths and marriages (opens in new window)"
          href="https://www.cambridgeshire.gov.uk/residents/births-deaths-and-marriages">
          <img src="assets/images/cambridgeshire-county-council-crest.svg" alt="Cambridgeshire County Council"
            class="logo">
        </a>
      </div>
    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <p class="footer-copyright">&copy; {{ currentYear }} Cambridgeshire County Council (Cambridgeshire
        Registration Service)</p>
      <span>Powered by
        <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)" class="footer-links"
          href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=cambridgeshire">bookinglab
          | GovBook</a></span>
    </div>
  </div>
</footer>
